import css from 'styled-jsx/css';

const styles = css.global`#banco-do-auto-pesado .container-pesado{
    display: flex;
    flex-direction: column;
}

#banco-do-auto-pesado .pesado-title {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    margin: 0;
}

#banco-do-auto-pesado .pesado-title b {
    color: #C00;
    font-weight: 800;
}

#banco-do-auto-pesado .pesado-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
    margin-top: 16px;
    max-width: 480px;
}

#banco-do-auto-pesado .pesado-paragrafo b {
    font-weight: 600;
}

#banco-do-auto-pesado .btn-banco-do-auto-pesado {
    width: 100%;
    height: 48px;
    max-width: 272px;
    margin: 0 auto 48px;
}

#banco-do-auto-pesado .link-banco-do-auto-pesado {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration: underline;
    display: flex;
    justify-content: center;
    margin-bottom: 48px;
}

#banco-do-auto-pesado .banco-do-auto-imagem {
    width: 100%;
    max-width: 350px;
    margin-top: 48px;
    margin-bottom: 16px;
}

#banco-do-auto-pesado .container-pesado {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

@media(min-width: 992px) {
    .mobile {
        display: none!important;
    }

    #banco-do-auto-pesado .pesado-title {
        max-width: unset;
        font-size: 34px;
    }

    #banco-do-auto-pesado {
        height: 409px;
        display: flex;
    }

    #banco-do-auto-pesado .container-pesado {
        flex-direction: row;
    }
}`;

export default styles;